// First, before Aurelia: on the control-edit page it takes the token out of the address.
import './control-edit-page';
import './jquery-global';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import Aurelia, { ConsoleSink, LoggerConfiguration, LogLevel } from 'aurelia';
import { DialogConfigurationClassic } from '@aurelia/dialog';
import { I18nConfiguration } from '@aurelia/i18n';
import { RouterConfiguration } from '@aurelia/router';
import { ValidationHtmlConfiguration, ValidationTrigger } from '@aurelia/validation-html';
import Backend from 'i18next-http-backend';
import { App } from './app';
import { AuthorizeHook } from './authorize-hook';
import { TrackCurrentRoute } from './current-route';
import { PageTitle } from './page-title';
import { FetchThePageAgainWhenAScriptIsGone } from './stale-script';
import { ValidInstanceHook } from './valid-instance-hook';
import * as environment from '../config/environment.json';
import { globalResources } from './resources';
import './validation/boolean-satisfies';

const translationAttributes = ['t', 'i18n'];

Aurelia.register(
  LoggerConfiguration.create({ level: environment.debug ? LogLevel.debug : LogLevel.warn, sinks: [ConsoleSink] }),
  RouterConfiguration.customize({ useUrlFragmentHash: false }),
  ValidationHtmlConfiguration.customize(options => {
    options.DefaultTrigger = ValidationTrigger.blur;
  }),
  TrackCurrentRoute,
  PageTitle,
  FetchThePageAgainWhenAScriptIsGone,
  ValidInstanceHook,
  AuthorizeHook,
  DialogConfigurationClassic.customize(settings => {
    settings.options.lock = true;
    settings.options.startingZIndex = 1338;
    settings.options.keyboard = ['Escape'];
  }),
  I18nConfiguration.customize(options => {
    options.translationAttributeAliases = translationAttributes;
    options.initOptions = {
      plugins: [Backend],
      backend: {
        loadPath: './locales/{{lng}}/{{ns}}.json?v=' + BUILD_TIMESTAMP,
      },
      ns: ['translation', '0049'],
      defaultNS: 'translation',
      fallbackNS: 'translation',
      attributes: translationAttributes,
      lng: 'en',
      fallbackLng: 'en',
      debug: false,
    };
  }),
  ...globalResources,
)
  .app({ host: document.querySelector('app-root'), component: App })
  .start();
